<template>
  <div class="access-denied">
    <div class="access-denied-card">
      <div class="access-denied-icon-wrap">
        <i class="bx bx-lock-alt"></i>
      </div>
      <h1>{{ $t('accessDenied.title') }}</h1>
      <p class="access-denied-message">{{ $t('accessDenied.message') }}</p>
      <router-link to="/" class="appButton" style="display: inline-flex; align-items: center; gap: 0.25rem; text-decoration: none;">
        <i class="bx bx-arrow-back"></i>
        {{ $t('accessDenied.backHome') }}
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.access-denied {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.access-denied-card {
  text-align: center;
  max-width: 400px;
}

.access-denied-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: rgba(117, 35, 35, 0.1);
  border: 1px solid rgba(117, 35, 35, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 1.75rem;
  color: #a63c3c;
}

.access-denied-message {
  color: #9aa0a8;
  font-size: 0.9375rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}
</style>
